import BootstrapOverlayTrigger, { OverlayTriggerProps } from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

let tooltipIdCounter = 0;

type ElementWithTooltipProps = Omit<OverlayTriggerProps, 'overlay'> & {
  children: JSX.Element;
  tooltip?: string | JSX.Element;
};

/**
 * Makes it easier to give tooltip capability to any component by wrapping it with this component.
 * Uses OverlayTrigger and Tooltip bootstrap components under the hood.
 */
const ElementWithTooltip = ({
  children,
  delay = { show: 250, hide: 250 },
  placement = 'bottom',
  tooltip,
  trigger,
}: ElementWithTooltipProps) => {
  if (!tooltip) {
    return children;
  }

  tooltipIdCounter += 1;

  return (
    <BootstrapOverlayTrigger
      placement={placement}
      delay={delay}
      overlay={<Tooltip id={`ElementWithTooltip-tooltip-${tooltipIdCounter}`}>{tooltip}</Tooltip>}
      {...(trigger ? { trigger } : {})}
    >
      {children}
    </BootstrapOverlayTrigger>
  );
};

export default ElementWithTooltip;
